<template>
    <form action="/billing/update-plan" method="POST" id="swap-subscription-form">

      <div v-if="selected_plan">
        <h1 class="display-3 font-secondary text-center mt-3 mb-0">£{{ ((parseFloat(selected_plan.price.replace(/[^\d.]/g, ''))) + (parseFloat(selected_plan.user_login_price.replace(/[^\d.]/g, '')) * parseInt(users))) }}</h1>
        <p class="text-center">per month, billed {{ selected_plan.period.toLowerCase() }}</p>
      </div>

      <div class="form-group">
          <select ref="plan" name="plan" class="form-control" id="plans" @change="updateSelected">
            <option v-for="(plan, plan_id) in plans" :value="plan['id']">{{ plan['name'] }}</option>
          </select>
      </div>

      <!-- CSRF Field -->
      <input type="hidden" name="_token" :value="csrf">

      <div class="spacer"></div>

      <button id="card-button" class="btn btn-primary btn-block btn-lg" :data-secret="secret">
          Update Subscription
      </button>

      <div v-if="selected_plan" class="text-center pt-2 px-5">
      
        <small v-if="selected_plan.period == 'Monthly'"  class="text-muted">Your card will be charged £{{ ((parseFloat(selected_plan.price.replace(/[^\d.]/g, ''))) * parseInt(users)).toFixed(2) }} + VAT today and ongoing {{ selected_plan.period.toLowerCase() }} for {{ users }} user<span v-if="parseInt(users) !== 1">s</span>.</small>
        <small v-if="selected_plan.period == 'Annually' || selected_plan.period == 'Yearly'"  class="text-muted">Your card will be charged £{{ ((parseFloat(selected_plan.price.replace(/[^\d.]/g, ''))) * parseInt(users) * 12).toFixed(2) }} + VAT today and ongoing {{ selected_plan.period.toLowerCase() }} for {{ users }} user<span v-if="parseInt(users) !== 1">s</span>.</small>

        <!-- <small v-if="selected_plan.period == 'Annually'" class="text-muted">Your card will be charged £{{ ((parseFloat(selected_plan.price.replace(/[^\d.]/g, ''))) + (parseFloat(selected_plan.user_login_price.replace(/[^\d.]/g, '')) * parseInt(users))).toFixed(2) }} +VAT for a full year's access for {{ users }} user<span v-if="parseInt(users) !== 1">s</span>.</small>
        <small v-if="selected_plan.period == 'Monthly'" class="text-muted">Your card will be charged £{{ ((parseFloat(selected_plan.price.replace(/[^\d.]/g, ''))) + (parseFloat(selected_plan.user_login_price.replace(/[^\d.]/g, '')) * parseInt(users))).toFixed(2) }} +VAT for a month's access for {{ users }} user<span v-if="parseInt(users) !== 1">s</span>.</small>
        <small v-if="selected_plan.period !== 'Annually' && selected_plan.period !== 'Monthly'" class="text-muted">Your card will be charged {{ selected_plan.price }} + VAT today and ongoing {{ selected_plan.period }} for {{ users }} user<span v-if="parseInt(users) !== 1">s</span>.</small> -->
      </div>

  </form>
</template>

<script>
    
import Noty from 'noty';

    export default {
        props: [
          'users',
        ],
        mounted(){

          var vm = this;

          axios.get('/billing/list-plans').then(response => {

            vm.plans = response.data;

            vm.selected_plan = response.data[0];


          }).catch(function(error){ vm.handleError(error) });



        },
        data () {
            return {
              csrf: document.head.querySelector('meta[name="csrf-token"]').content,
              plans: null,
              selected_plan: null,
            }
        },
        methods: {
            updateSelected: function(){

              this.selected_plan = this.plans.find(plan => plan.id == this.$refs.plan.value);

            },
      }
    }
</script>
